import { createClientComponentClient } from '@supabase/auth-helpers-nextjs';

let supabaseInstance: ReturnType<typeof createClientComponentClient> | null = null;

export function getSupabaseClient() {
  if (!supabaseInstance) {
    // console.log('🆕 創建唯一 Supabase 客戶端');
    supabaseInstance = createClientComponentClient();
    // console.log('創建 Supabase 客戶端實例', {
    //   url: process.env.NEXT_PUBLIC_SUPABASE_URL,
    //   anonKeyProvided: !!process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY
    // });
  }
  return supabaseInstance;
}
